<template>
    <div class="header" :style="backgroundStyle">
        <!-- S 返回按钮 -->
        <div class="back" v-if="isApp" @click="back">
            <span class="icon_arrow-right"></span>
        </div>
        <!-- E 返回按钮 -->
        <!-- S 公司信息 -->
        <div class="company">
            <img class="company__logo"
                v-if="showCompanyLogoOrName === SHOW_COMPANY_LOGO_OR_NAME.LOGO" 
                :src="company.logo">
            <div class="company__name"
                :style="{color: colorStyle}"
                v-else><span v-if="is_input">正在输入中...</span><span v-else>{{companyName}}</span></div>
        </div>
        <!-- E 公司信息 -->

        <!-- S 排队中 -->
        <div class="in-queue"
            @click="noQueue"
            v-if="isInQueue && isInSession">
            <span v-if="isMobile"
                class="in-queue__text">放弃排队</span>
            <div v-else
                class="in-queue__btn" :style="{color: $store.state.lingkeColor}">
                放弃排队
            </div>
        </div>
        <!-- E 排队中 -->
        <!-- S 聊天对象 -->
        <div class="chat-target"
            v-if="!isInQueue && isInSession">
            <div
                class="chat-target__item"
                v-for="(item, index) in chatTargetList"
                :key="index"
                :class="`chat-target__${item.key}`"
                v-show="item.key !== chatTarget"
                @click="changeChatTargetThrottled(item.sendText)">
                <div v-if="isMobile" class="chat-target__icon_box">
                    <template v-if="showbtn">
                        <icon
                            class="chat-target__icon"
                            :name="themeIcon(item.icon)"
                            :width="20" :height="20" />
                        <!-- <div class="chat-target__text">{{item.name}}</div> -->
                    </template>
                </div>
                <template v-else>
                    <div 
                        class="chat-target__btn" :style="{ color: colorStyle }" v-if="showbtn">
                        <span class="icon_to_kf" :style="{ color: colorStyle }"></span>
                        {{item.name}}
                    </div>
                </template>
            </div>
        </div>
        <!-- E 聊天对象 -->

        <!-- S 结束会话 -->
        <div class="end-call" v-if="!isNewPage && isInSession" :class="{mobile: isMobile}">
            <div v-if="isInPage" class="narrow pointer" @click="narrow">
                <icon
                    :name="themeIcon('minus')"
                    :width="18" :height="18" />
            </div>
            <div v-if="isMobile" class="end-call-mobile" @click="endCall">
                <div class="end-call-mobile__icon" :style="{ borderColor: colorStyle }">
                    <icon
                        :name="themeIcon('close')"
                        :width="10" :height="10" />
                </div>
                <!-- <div class="end-call-mobile__text">结束</div> -->
            </div>
            <template v-else-if="isInSession">
                <div class="end-call-icon pointer" @click="endCall">
                    <icon
                        :name="themeIcon('close')"
                        :width="18" :height="18" />
                </div>
            </template>
        </div>

        <div 
            class="end-call-btn" v-if="isNewPage && isInSession" @click="endCall">
            结束
        </div>
        <!-- E 结束会话 -->
    </div>
</template>

<script>
    import { Dialog } from 'vant'
    import Icon from '@/components/Icon'
    import throttle from 'lodash.throttle'
    import { putNoQueue, closeSession } from '@/api/chat'
    import { inObjectValues, getRequest } from '@/utils'
    import { sendMessage, sendMessageOnlyFrontEnd } from '@/utils/message_send'
    import { MESSAGE_NAME, SHOW_COMPANY_LOGO_OR_NAME, CHAT_TARGET } from '@/constants/message'

    const THROTTLE_TIME = 1000

    const CHAT_TARGET_LIST = [
        {
            key: CHAT_TARGET.HUMAN,
            icon: 'to_kf',
            name: '转人工',
            sendText: '人工'
        }
    ]

    export default {
        name: 'TheHeader',
        props: {
            showCompanyLogoOrName: {
                type: String,
                required: true,
                validator (value) {
                    if (value === '') return true
                    return inObjectValues(SHOW_COMPANY_LOGO_OR_NAME, value)
                }
            },
            isInQueue: {
                type: Boolean,
                required: true
            },
            chatTarget: {
                type: String,
                required: true,
                validator (value) {
                    return [CHAT_TARGET.HUMAN, CHAT_TARGET.ROBOT, ''].includes(value)
                }
            },
            isSupportHuman: {
                type: String,
                required: true
            }
        },
        data () {
            return {
                SHOW_COMPANY_LOGO_OR_NAME,
                changeChatTargetThrottled: throttle(this.changeChatTarget, THROTTLE_TIME),
                is_input:false
            }
        },
        computed: {
            isMobile () {
                return this.$eventBus.isMobile
            },
            isDesktop () {
                return this.$eventBus.isDesktop
            },
            company () {
                return this.$eventBus.company
            },
            humanUsers () {
                return this.$eventBus.humanUsers
            },
            currentHumanUser () {
                return this.$eventBus.currentHumanUser
            },
            showbtn () {
                let show = true
                if (this.chatTarget == 'robot') {
                    show = !this.$eventBus.robot.hide_human_button
                } else {
                    show = true
                }
                return show
            },
            chatTargetList () {
                if(getRequest().robot_key) {
                    return
                }else{
                    if (this.isSupportHuman=='robot') {
                        return 
                        //CHAT_TARGET_LIST
                    } else if(this.isSupportHuman=='human') {
                        return 
                        //[CHAT_TARGET_LIST[1]]
                    } else {
                        return CHAT_TARGET_LIST
                    }
                }
            },
            isInSession () {
                return this.$store.state.isInSession
            },
            isInPage () {
                return getRequest().open_way === 'in_page'
            },
            isNewPage () {
                return getRequest().open_way === 'new_page'
            },
            companyName () {
                if (this.isInSession && this.chatTarget === 'human' && !this.isInQueue && this.currentHumanUser && this.currentHumanUser.nickname && this.company.name) {
                    return `${this.company.name} - ${this.currentHumanUser.nickname}`
                }
                return this.company.name
            },
            theme () {
                return this.$eventBus.theme
            },
            backgroundStyle () {
                if (this.theme === 'white') {
                    return {
                        background: '#fff'
                    }
                }
                return {
                    background: '#000'
                }
            },
            colorStyle () {
                if (this.theme === 'white') {
                    return '#333'
                }
                return '#fff'
            },
            isApp () {
                const channel = getRequest().channel
                if (['jh_app', 'jhmall_app', 'jhcollection_app'].includes(channel)) {
                    return false
                }
                const ua = navigator.userAgent
                return ua.indexOf('x-cordova-platform') > -1
            }
        },
        created () {
            this.$eventBus.$on('showinputstatus', (data)=>{
                this.is_input = data.is_input
            })
        },
        methods: {
            themeIcon (name) {
                if (this.theme === 'white') {
                    return `${name}_black`
                }
                return name
            },
            changeChatTarget (text) {
                sendMessage({
                    type: 'base',
                    detailType: MESSAGE_NAME.TEXT,
                    content: text
                })
            },
            // 放弃排队
            async noQueue () {
                if (!this.isInQueue) {
                    return
                }

                try {
                    await Dialog.confirm({
                        message: '确定放弃排队？'
                    })
                    // cancel 为 Promise.reject 不会执行下面一行，直接到 catch
                    confirm.call(this)
                } catch (err) {
                    // eslint-disable-next-line
                    console.error(err)
                }

                async function confirm () {
                    try {
                        await putNoQueue(this.$eventBus.uid)
                        /**
                         * 退出排队成功，服务器会推 chat_notice 事件
                         * 但不会推 chat_status 事件
                         * 故需要前端主动切换
                         */
                        this.$emit('setChatHost', CHAT_TARGET.ROBOT)
                    } catch (err) {
                        // eslint-disable-next-line
                        console.error(err)
                        if (err.status !== 200) {
                            this.$emit('getChatHost')
                        }
                    }
                }
            },
            // 结束会话
            endCall () {
                if (!this.isInSession) {
                    return
                }
                const endCall = () => {
                    this.$store.commit('setData', {
                        key: 'isInSession',
                        value: false
                    })
                    if (this.isInPage) {
                        this.narrow()
                    }
                    if (this.isMobile) {
                        sendMessageOnlyFrontEnd({
                            type: 'event',
                            detailType: MESSAGE_NAME.EVENT_NORMAL,
                            content: '您已结束本次服务，刷新可继续会话'
                        })
                    }
                    this.$emit('setChatHost', CHAT_TARGET.ROBOT)
                }
                closeSession(this.$eventBus.uid).then(() => {
                    endCall()
                }).catch(err => {
                    if (err.data.code === 500001) {
                        endCall()
                    }
                })
            },
            // 页面内嵌样式增加最小化功能
            narrow () {
                window.top.postMessage('narrow', '*')
            },
            back () {
                const success = () => {}
                const fail = err => {
                    console.error(err)
                }
                // eslint-disable-next-line
                if (typeof cordova !== 'undefined' && typeof cordova.exec === 'function') {
                    // eslint-disable-next-line
                    cordova.exec(success, fail, 'SWCNavigatorPlugin', 'pop', [{
                        animated: true // 是否开启动画
                    }])
                }
            }
        },
        components: {
            Icon
        }
    }
</script>

<style lang="scss" scoped>
    .header {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px;
        height: 48px;;
        background-color: #fff;
        z-index: 2;
        box-shadow: 0 2px 6px 0 rgba(197,206,238,0.12);
    }

    .back {
        transform: rotate(180deg) scale(1.2);
        color: #fff;
    }

    .company {
        display: inline-flex;
        align-items: center;
        flex-grow: 1;

        &__logo {
            width: auto;
            height: 36px;
        }

        &__name {
            max-width: 200px;
            font-size: 16px;
            line-height: (40 / 18);
            @include text-line;
        }

        @include mobile {
            &__logo, &__name {
                @include absolute-center;
            }
        }
    }
    .end-call {
        display: flex;
        margin-left: 15px;
        color: #fff;
        &.mobile {
            margin-left: 10px;
        }
        &-mobile {
            height: 39px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            &__icon {
                display: inline-block;
                font-size: 12px;
                width: 18px;
                height: 18px;
                padding: 3px;
                border: 1px solid #fff;
                border-radius: 50%;
                margin: 1px;
            }
            &__text {
                font-size: 10px;
                line-height: 14px;
                margin-top: 2px;
            }
        }
    }

    .narrow {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 18px;
        height: 18px;
        margin-right: 20px;
    }

    .end-call-btn {
        width: 66px;
        height: 26px;
        line-height: 24px;
        border: 1px solid #FFFFFF;
        border-radius: 16px;
        margin-left: 10px;
        color: #FFFFFF;
        text-align: center;
        cursor: pointer;
    }

    .pointer{
        cursor: pointer;
    }

    .chat-target,
    .in-queue {
        flex-shrink: 0;
        flex-grow: 0;

        &__icon_box {
            position: relative;
            display: inline-flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding-right: 11px;

            & > .chat-target__icon {
                font-size: 25px;
                color: $primary-text-color;

                &::before {
                    display: inline-block;
                }
            }
            & > .chat-target__text {
                color: #fff;
                margin-top: 2px;
                font-size: 10px;
            }

            &::after {
                content: '';
                position: absolute;
                right: 0;
                display: inline-block;
                width: 1px;
                height: 16px;
                opacity: 0.1;
                background: #FFFFFF;
            }
        }

        // &__icon {
        //     font-size: 25px;
        //     color: $primary-text-color;

        //     &::before {
        //         display: inline-block;
        //     }
        // }

        &__btn {
            width: 76px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            font-size: 12px;
            background: transparent;
            border-radius: 16px;
            @include flex-center;
            cursor: pointer;
            user-select: none;
            // &:hover {
            //     background: $primary-color-darken;
            // }
        }
    }

    .in-queue {
        &__text {
            font-size: 13px;
            color: #fff;
            line-height: 1;

            // &:active {
            //     color: $primary-color-darken;
            // }
        }
    }

    .chat-target {
        @include flex-center;
        margin-left: 10px;
        &__item {
            text-align: center;
            display: flex;
            align-items: center;
        }
    }
</style>
